// NOTE: taken from here https://stackoverflow.com/a/57842203

const RES_TIMEZONE = "America/New_York";
const RES_TIMEZONE_FALLBACK = "US/Eastern";

export const timeZoneTransformer = (
  input: Date,
  timeZone: string,
  fallbackTimezone = timeZone
) => {
  const date = toUTCDateTime(input);

  const utcDate = fallbackToAlternativeTimezone(date, "UTC", "UTC");
  const resDate = fallbackToAlternativeTimezone(
    date,
    timeZone,
    fallbackTimezone
  );
  const offset = utcDate.getTime() - resDate.getTime();

  date.setTime(date.getTime() + offset);

  return date;
};

export function forceResTimezone(input: Date) {
  return timeZoneTransformer(input, RES_TIMEZONE, RES_TIMEZONE_FALLBACK);
}

function toUTCDateTime(date: Date): Date {
  return new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
      date.getUTCMilliseconds()
    )
  );
}

const fallbackToAlternativeTimezone = (
  date: Date,
  primary: string,
  fallback: string
) => {
  try {
    return new Date(date.toLocaleString("en-US", { timeZone: primary }));
  } catch (_e) {
    return new Date(date.toLocaleString("en-US", { timeZone: fallback }));
  }
};
